import { useEffect, useMemo, useRef } from "react";

import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { cn } from "@design-lab/shared/lib";

import { useArtwork } from "@design-lab/entities/artwork";
import { useMenuState } from "../model/useMenuState";
import { LeftMenu, MainContent } from "./components";
import { MobileSkeletonLoader } from "./components/MobileSkeletonLoader";
import { SkeletonLoader } from "./components/SkeletonLoader";

export function WeaveDesignLab() {
  const { activeMenu, handleMenuChange, showLoader } = useMenuState(undefined, {
    enableInitialization: true
  });
  const { isDesktop } = useResponsive();
  const { someArtworkLoading, front, back } = useArtwork();
  const hasEverHadImageRef = useRef(false);

  const hasExistingImage = useMemo(
    () =>
      Boolean(
        front.state.context.artwork ||
          back.state.context.artwork ||
          front.state.context.artworkId ||
          back.state.context.artworkId
      ),
    [
      front.state.context.artwork,
      back.state.context.artwork,
      front.state.context.artworkId,
      back.state.context.artworkId
    ]
  );

  useEffect(() => {
    if (hasExistingImage || someArtworkLoading) {
      hasEverHadImageRef.current = true;
    }
  }, [hasExistingImage, someArtworkLoading]);

  if (showLoader && !hasEverHadImageRef.current) {
    return isDesktop ? <SkeletonLoader /> : <MobileSkeletonLoader />;
  }

  return (
    <div
      className={cn(
        "flex h-full w-full bg-white",
        isDesktop
          ? "gap-8 rounded-xl border border-gray-300 p-6 shadow-sm"
          : "flex-col overflow-hidden"
      )}
    >
      <LeftMenu activeMenu={activeMenu} onMenuChange={handleMenuChange} />
      <div className={cn("flex-1", !isDesktop && "mt-3 overflow-hidden")}>
        <MainContent activeMenu={activeMenu} />
      </div>
    </div>
  );
}
